import { buildIValueLabelPairFromValue } from '../attributes/buildIValueLabelPairFromValue';
import { matchAttribute } from '../attributes/matchAttribute';
import { IValueLabelPair } from '../../modules/Form/Select';
import { ISelectedSubOptions } from 'src/components/ProductList/interfaces/ISelectSubOption';

export const getAllSizeForVariantsFromVariants = (
        variant: GQL.IProductVariant,
        variants: Array<GQL.IProductVariant>, sizeAttributes: Array<GQL.IAttribute>,
        language: string, selectedSubOptions: ISelectedSubOptions
    ) => {
    const sizes = new Array<IValueLabelPair>();
    let relevantAttribute: GQL.IAttribute | undefined;
    const relevantVariants = variants;

    for (const v of relevantVariants) {
        relevantAttribute = matchAttribute(v, sizeAttributes);
        if (relevantAttribute == undefined) {
            break;
        }
    }

    if (relevantAttribute == undefined) {
        return undefined;
    }

    for (const v of relevantVariants) {
        const tempValueId = (v.definition || {})[relevantAttribute.id];
        if (tempValueId) {
            const value = (relevantAttribute.values || []).find(val => val.id == tempValueId);
            const subOption = (selectedSubOptions[relevantAttribute.id] || '').toUpperCase();

            if (value) {
                sizes.push({ value: v.id, label: buildIValueLabelPairFromValue(value, language, subOption, relevantAttribute).label });
            }
        }
    }

    return sizes;
};



// WEBPACK FOOTER //
// ./src/helpers/products/getAllSizeForVariantsFromVariants.ts